import { render } from "./StockNotification.vue?vue&type=template&id=68f8bdde&scoped=true"
import script from "./StockNotification.vue?vue&type=script&lang=js"
export * from "./StockNotification.vue?vue&type=script&lang=js"

import "./StockNotification.vue?vue&type=style&index=0&id=68f8bdde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f8bdde"]])

export default __exports__